import { render, staticRenderFns } from "./HCDetails.vue?vue&type=template&id=cd2d2c9a"
import script from "./HCDetails.vue?vue&type=script&lang=js"
export * from "./HCDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports